import { useContext } from 'react';
import ddt from '@wix/da-ddt';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useDeviationViewContext } from '../../../Context';
import { isDeviationPixelArt, isFileLargerThanSize } from '../../_helpers';
import { useMediaService } from './useMediaService';
/** gets you:
 *  - src and preview files,
 *  - srcset and available sizes,
 *  - as well as display characteristics like gif, pixelated, zoomable, etc. */ export function useFullview({ stageWidth, stageHeight, source, allowFullviewSrcsetForPngs }) {
    const isMobile = useContext(MobileContext);
    const { isFullscreen } = useDeviationViewContext();
    const { isPreviewable, previewSrcSet, fullview, isGif, isPng } = useMediaService(source);
    const { src, srcSet, sizes, previewFile, srcFile } = previewSrcSet;
    // Non images don't have anything to show
    if (!isPreviewable) {
        return {};
    }
    const isPixel = isDeviationPixelArt(source);
    const isBiggerThanStage = !!srcFile && // must have a fullview
    !isGif && // must not be a gif as selecting sized one will give you static jpg sometimes
    isFileLargerThanSize(srcFile, stageWidth, stageHeight); // must be larger than the artstage
    var _srcFile_filesize;
    // Large gif handling, must have a non-gif preview, 5MB Mobile only
    const isLargeGif = isGif && /\.jpg\?/.test(previewFile.src) && isMobile && ((_srcFile_filesize = srcFile === null || srcFile === void 0 ? void 0 : srcFile.filesize) !== null && _srcFile_filesize !== void 0 ? _srcFile_filesize : 0) > 5242880;
    // Remove the srcset if its a gif and we are not showing the playbutton
    const calcSrcSet = isGif && !isLargeGif ? '' : srcSet;
    // For unpublished pngs
    // output logic is:
    // use fullview
    // disable large gif handling
    // disable srcset
    if (!allowFullviewSrcsetForPngs && isPng) {
        ddt.log('deviation', 'Using unpublished fullview attr', {
            src,
            srcSet,
            sizes,
            previewFile,
            srcFile
        });
        if (fullview) {
            return {
                previewFile: fullview,
                srcFile: fullview,
                src: fullview.src,
                isPixel,
                isFullscreen,
                canZoom: isBiggerThanStage,
                isGif,
                isLargeGif: false
            };
        }
    }
    ddt.log('deviation', 'Using fullview attr', {
        src,
        srcSet,
        sizes,
        previewFile,
        srcFile
    });
    return {
        previewFile,
        srcFile,
        srcSet: calcSrcSet,
        sizes,
        src,
        isPixel,
        isFullscreen,
        canZoom: isBiggerThanStage,
        isGif,
        isLargeGif
    };
}

//# sourceMappingURL=useFullview.js.map